import React, { FunctionComponent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@blueprintjs/core';
import { CollectionFunctionGroupMenuActionsType } from 'routes/CollectionFunctionGroup/CollectionFunctionGroup.types';
import ModalDialog from 'shared/modal/dialog';
import { CollectionFunctionGroup } from 'data/collectionFunctionGroup/collectionFunctionGroup.types';
import './collection-function-group-list-menu.scss';

type Props = {
  selectedCollectionFunctionGroup?: CollectionFunctionGroup;
  hasPrivilegeToCreateNew: boolean;
  hasPrivilegeToDelete: boolean;
  onEdit: () => void;
  onDelete: () => void;
}

const CollectionFunctionGroupListMenu: FunctionComponent<Props> = ({
  selectedCollectionFunctionGroup,
  hasPrivilegeToCreateNew,
  hasPrivilegeToDelete,
  onEdit,
  onDelete,
}: Props) => {

  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const { t } = useTranslation();

  const handleOpenDeleteDialog = () => {
    setIsDeleteDialogOpen(true);
  };

  const handleCloseDeleteDialog = () => {
    setIsDeleteDialogOpen(false);
  };

  const handleDelete = () => {
    onDelete();
    setIsDeleteDialogOpen(false);
  };

  if (selectedCollectionFunctionGroup == null) {
    return null;
  }

  const hasCollectionFunctions = selectedCollectionFunctionGroup.cfs.length > 0;

  return (
    <div data-testid="CollectionFunctionGroupListMenu" className="collection-function-group-list-menu">
      {hasPrivilegeToCreateNew && (
        <Button
          className="collection-function-group-list-menu-button"
          data-testid={`${CollectionFunctionGroupMenuActionsType.Edit}-button`}
          text={t('collectionFunction.grid.edit')}
          onClick={onEdit}
        />
      )}
      {hasPrivilegeToDelete && !hasCollectionFunctions && (
        <Button
          className="collection-function-group-list-menu-button"
          data-testid={`${CollectionFunctionGroupMenuActionsType.Delete}-button`}
          text={t('collectionFunction.grid.delete')}
          onClick={handleOpenDeleteDialog}
        />
      )}
      <ModalDialog
        width="500px"
        isOpen={isDeleteDialogOpen}
        title={t('collectionFunctionGroup.deletePopup.title')}
        displayMessage={t('collectionFunctionGroup.deletePopup.message', { name: selectedCollectionFunctionGroup.name })}
        actionText={t('collectionFunctionGroup.deletePopup.action')}
        onSubmit={handleDelete}
        onClose={handleCloseDeleteDialog}
      />
    </div>
  );
};

export default CollectionFunctionGroupListMenu;
